import type { JSX } from "react";
// Form primitives, built on the shadcn/ui input chrome (components/ui). Same
// exports/API as before so every caller stays unchanged; a `Field` wraps its
// control in a <label> so the caption focuses the control on click.

import type { ComponentPropsWithoutRef, ReactNode } from "react";
import { Input } from "./ui/input.js";
import { NativeSelect } from "./ui/native-select.js";
import { Textarea as UITextarea } from "./ui/textarea.js";

export function Field({ label, children }: { label: string; children: ReactNode }): JSX.Element {
  return (
    <label className="mb-3 flex flex-col gap-1.5">
      <span className="text-muted-foreground text-xs">{label}</span>
      {children}
    </label>
  );
}

export function TextInput(props: ComponentPropsWithoutRef<"input">): JSX.Element {
  return <Input {...props} />;
}

export function Select(
  props: ComponentPropsWithoutRef<"select"> & { children: ReactNode },
): JSX.Element {
  return <NativeSelect {...props} />;
}

export function Textarea(props: ComponentPropsWithoutRef<"textarea">): JSX.Element {
  return <UITextarea {...props} />;
}
